var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.559023 0.153154C0.369244 0.266229 0.21576 0.434988 0.117781 0.638307C0.0198015 0.841626 -0.0183205 1.07047 0.00818606 1.29621L1.68849 20.0435C1.7959 20.9538 2.83131 21.378 3.5069 20.7885L6.49999 17.5L8.99999 21.5C9.91442 23.1464 11.5878 23.3717 13.1711 22.421C14.7551 21.4703 15.4144 20.1464 14.5 18.5L12.0594 14.1902L16.2682 13.1286C17.097 12.8148 17.2614 11.6709 16.5569 11.119L1.78056 0.232225C1.60671 0.0962523 1.39832 0.0162864 1.1812 0.00223172C0.96407 -0.011823 0.747747 0.0406511 0.559023 0.153154ZM2.53332 3.71549L13.5823 11.6843L8.85338 12.6128L8.87384 12.6459L12.6888 19.2401C13.0063 19.8119 12.6096 20.0886 12.0594 20.4188C11.5093 20.7489 11.0805 20.9679 10.763 20.3961L6.94802 13.8019L6.92512 13.7561L3.64678 17.6481L2.53332 3.71549Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectarrow);
export default __webpack_public_path__ + "static/media/selectarrow.eb7e15076a382e57924f7a4222ac61ec.svg";
export { ForwardRef as ReactComponent };